export default "__VITE_ASSET__YSz$xfrX__"